import {Price} from './Price';

export type PriceValue = Price & {
  fromWithVat?: boolean;
};
